<template>
	<div class="app">
		<h1>Date Range Picker Demo</h1>

		<DateRangePicker
			v-model="dateRange"
			:published-range="publishedDateRange"
			:planning-range="planningDateRange"
			@change="handleDateChange"
			@update:view="handleViewUpdate"
		/>

		<div class="actions" style="margin-top: 1rem">
			<button @click="clearSelection" class="btn-clear">{{ $t('performance_metrics.btn_clear') }}</button>
		</div>

		<div v-if="dateRange.startDate && dateRange.endDate" class="result">
			<h3>Selected Range:</h3>
			<p>Start: {{ formatDate(dateRange.startDate) }}</p>
			<p>End: {{ formatDate(dateRange.endDate) }}</p>
		</div>
	</div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import DateRangePicker from '../../shared/components/DateRangePicker.vue';
import type { DateRange, DateView } from '../../shared/types/date-range-picker';
import { DateTime } from 'luxon';

const store = useStore();
const locale = computed(() => store.state.profile.locale);

const dateRange = ref<DateRange>({
	startDate: null,
	endDate: null,
});

const selectedView = ref<{ value: DateView; label: string }>({
	value: 'custom',
	label: 'Custom',
});

const publishedDateRange = computed(
	(): DateRange => ({
		startDate: new Date(2026, 0, 1),
		endDate: new Date(2026, 0, 19),
	})
);

const planningDateRange = computed(
	(): DateRange => ({
		startDate: new Date(2026, 0, 20),
		endDate: new Date(2026, 1, 5),
	})
);

const handleViewUpdate = (view: { value: DateView; label: string }) => {
	selectedView.value = view;
};

const handleDateChange = (range: DateRange) => {
	console.log('Date range changed:', range);
};

const clearSelection = () => {
	dateRange.value = { startDate: null, endDate: null };
	selectedView.value = { value: 'custom', label: 'Custom' };
};

const formatDate = (date: Date | null) => {
	if (!date) {
		return '';
	}

	return DateTime.fromJSDate(date).toFormat(locale.value?.dateFormat);
};
</script>

<style scoped>
.app {
	padding: 2rem;
}

h1 {
	margin-bottom: 2rem;
}

.result {
	margin-top: 2rem;
	padding: 1rem;
	background: #f3f4f6;
	border-radius: 0.5rem;
}

.btn-clear {
	padding: 0.5rem 1rem;
	background: #e5e7eb;
	color: #374151;
	border: none;
	border-radius: 0.25rem;
	cursor: pointer;
	font-weight: 500;
}

.btn-clear:hover {
	background: #d1d5db;
}
</style>
